import { render } from "./MiddleImage.vue?vue&type=template&id=4a2aede8&scoped=true"
import script from "./MiddleImage.vue?vue&type=script&lang=js"
export * from "./MiddleImage.vue?vue&type=script&lang=js"

import "./MiddleImage.vue?vue&type=style&index=0&id=4a2aede8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2aede8"]])

export default __exports__